"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _echarts = _interopRequireDefault(require("echarts"));
require("./china.js");
var _chart = require("@/utils/chart");
var _resize = _interopRequireDefault(require("./mixins/resize"));
//
//
//
//

require('echarts/theme/macarons'); // echarts theme
var _default2 = {
  mixins: [_resize.default],
  props: {
    data: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'line'
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    desc: {
      type: Boolean,
      // 数据是倒序，倒序的展示则是从大到小
      default: false
    }
  },
  data: function data() {
    return {
      chart: null
    };
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler: function handler(val) {
        this.updateChart(val);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    /**
     * 初始化图表
     */
    initChart: function initChart() {
      this.chart = _echarts.default.init(this.$el, 'macarons');
      this.chart.setOption(this.data, true);
    },
    /**
     * 重绘图表
     */
    updateChart: function updateChart() {
      var _this = this;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        data = _ref.data,
        idKey = _ref.idKey,
        filedKeys = _ref.filedKeys;
      this.$nextTick(function () {
        _this.initChart();
        var options = null;
        switch (_this.type) {
          case 'line':
            options = (0, _chart.getLineChartOption)(data, idKey, filedKeys, _this.desc);
            break;
          case 'bar':
            options = (0, _chart.getBarChartOption)(data, idKey, filedKeys, _this.desc);
            break;
          case 'map':
            options = (0, _chart.getMapChartOption)(data, idKey, filedKeys, _this.desc);
            break;
          case 'pie':
            options = (0, _chart.getPieChartOption)(data, idKey, filedKeys, _this.desc);
            break;
          case 'funnel':
            options = (0, _chart.getFunnelChartOption)(data, idKey, filedKeys);
            break;
          default:
            break;
        }
        if (options) {
          // 合并配置
          options = (0, _chart.optionUpdate)(_this.options, options);
          _this.chart.setOption(options);
        }
      });
    }
  }
};
exports.default = _default2;